// dependences
import PropTypes from "prop-types";
import React from "react";

// styles
import css from "./Style.module.scss";

const GoalCardSkeleton = ({ width, style = null, className = null }) => {
	const baseStyle = {
		width,
		...style,
	};

	return (
		<div
			className={`${css.Main} ${className} ${css.isSkeleton}`}
			style={baseStyle}
			data-testid="goal-card-skeleton"
		>
			<div className={css.card}>
				<div className={css.content}>
					<div className={css.skeletonPieces}>
						<div className={css.skeletonTitle} />
						<div className={css.skeletonProgress} />
						<div className={css.skeletonData} />
						<div className={css.skeletonZipContainer}>
							<div className={css.skeletonZip} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

GoalCardSkeleton.propTypes = {
	style: PropTypes.object,
	width: PropTypes.number.isRequired,
	className: PropTypes.string,
};

export default GoalCardSkeleton;
